/* eslint-disable */
import { initialAbility } from "@/libs/acl/config";
import BaseService from "../../BaseService";

const { http } = BaseService();

// API

export function PhongBanGetList(data) {
  return http({
    url: "PhongBan/get-list-phong-ban-by-id/" + data,
    method: "get",
  });
}

export function PhongBanCreate(postdata) {
  const data = { ...postdata };
  return http({
    url: "PhongBan/Create",
    method: "post",
    data,
  });
}

export function PhongBanUpdate(postdata) {
  const data = { ...postdata };
  return http({
    url: "PhongBan/Update",
    method: "post",
    data,
  });
}

export function PhongBanDelete(postdata) {
  const data = { ...postdata };
  return http({
    url: "PhongBan/Delete",
    method: "post",
    data,
  });
}
